/**
 * 服務暫停訊號（Layer 2 tenant / Layer 1 system）。
 * axios 攔截器偵測 503 + X-Service-Suspended header → triggerSuspend(scope)；
 * SystemContext 於 mount 註冊 handler → setIsService(false) + 顯 MaintenancePage。
 * （axios 無法直接拿 React context setter，用此 module-level 橋接。）
 */
export type SuspendScope = 'system' | 'tenant';

let handler: ((scope: SuspendScope) => void) | null = null;

export const onSuspend = (cb: (scope: SuspendScope) => void): (() => void) => {
  handler = cb;
  return () => { if (handler === cb) handler = null; };
};

export const triggerSuspend = (scope: SuspendScope): void => {
  handler?.(scope);
};
